module.exports = __webpack_public_path__ + "img/icon_arrow.4b2fb087.svg";